import React from "react";
import { FilePicker } from "../../formik-material-ui";
import { FastField } from "formik";

export default function FFilePicker(props) {
  return (
    <FastField component={FilePicker} margin="dense" fullWidth {...props} />
  );
}
